<template>
  <div>
    <div>
      <Multiselect
        v-model="vybraneStitky"
        :options="vsechnyStitky"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :taggable="true"
        :hideSelected="true"
        label="nazev"
        track-by="id"
        placeholder="Vyber štítky"
        @select="onSelect"
        @remove="onRemove"
        @tag="onTag"
      />
    </div>
    <br />
    <div class="proMobil">
      <label for="novyStitek" class="form-label">Přidat štítek</label>
      <input
        id="novyStitek"
        type="text"
        ref="manualInput"
        class="form-control"
        placeholder="Zadej název a stiskni Enter"
        @keydown.enter.prevent="manualTagCreate"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Multiselect from "vue-multiselect";
import { Top } from "../js/class/Top.js";
import { Url } from "../js/class/Url.js";
import { LadzoConsole as Lc } from "../js/global/ladzo-console.js";

const vsechnyStitky = ref([]);
const vybraneStitky = ref([]);

const manualInput = ref(null);
onMounted(() => {
  const Dl = Top.DataLayer;
  vsechnyStitky.value = Dl.StitkyMistaAll || [];
  vybraneStitky.value = Dl.StitkyMista || [];
});

function manualTagCreate() {
  const nazev = manualInput.value?.value?.trim();
  if (nazev) {
    onTag(nazev);
    manualInput.value.value = "";
  }
}

function onSelect(option) {
  Lc.f("Přidán štítek", option);
  fetch(`${Url.STITKY_MIST_ADD}?json`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id_mista: Top.DataLayer.Misto.id,
      id_stitku: option.id,
      typ_akce: "onSelect",
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (!data.stav) Lc.err("Nepodařilo se přidat štítek", data);
    })
    .catch((err) => Lc.err("Chyba při přidávání štítku", err));
}

function onRemove(option) {
  Lc.f("Odebrán štítek", option);
  fetch(`${Url.STITKY_MIST_DELETE}?json`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id_mista: Top.DataLayer.Misto.id,
      id_stitku: option.id,
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (!data.stav) Lc.err("Nepodařilo se odebrat štítek", data);
    })
    .catch((err) => Lc.err("Chyba při odebírání štítku", err));
}

function onTag(nazev) {
  Lc.f("Vytvořen nový štítek", nazev);
  fetch(`${Url.STITKY_MIST_ADD}?json`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id_mista: Top.DataLayer.Misto.id,
      nazev_stitku: nazev,
      typ_akce: "onTag",
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.stav) {
        Lc.log("Vytvořen nový štítek", data);
        const novy = { id: data.stitek.id, nazev: data.stitek.nazev };
        vsechnyStitky.value.push(novy);
        vybraneStitky.value.push(novy);
      } else {
        Lc.err("Nepodařilo se vytvořit štítek", data);
      }
    })
    .catch((err) => Lc.err("Chyba při vytváření štítku", err));
}
</script>

<style scoped>
@media (min-width: 768px) {
  .proMobil {
    display: none !important;
  }
}
</style>
